// extracted by mini-css-extract-plugin
module.exports = {"content":"edit-password_content__g0gwK","wrapper":"edit-password_wrapper__aMAwo"};